import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _bookedEntity = {
    singleSession: '_singleSession',
    setOfSessions: '_setOfSessions',
    location: '_location',
};
var _booking = {
    created: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    bookedEntity: '_bookedEntity',
    formInfo: '_formInfo',
    paymentDetails: '_paymentDetails',
};
var _contactDetails = { fullAddress: '_address' };
var _enrollRequest = {};
var _enrollResponse = { booking: '_booking' };
var _formInfo = { contactDetails: '_contactDetails' };
var _invoiceDetails = {
    issueDate: 'google.protobuf.Timestamp',
    dueDate: 'google.protobuf.Timestamp',
};
var _leaveRequest = {};
var _leaveResponse = {};
var _listWaitingListRequest = {};
var _listWaitingListResponse = {};
var _location = {
    customAddress: '_address',
    businessLocation: '_locationsLocation',
};
var _locationsAddress = { geocode: '_locationsAddressLocation' };
var _locationsAddressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _locationsLocation = { address: '_locationsAddress' };
var _paymentDetails = {
    wixPayDetails: '_wixPayDetails',
    wixPayMultipleDetails: '_wixPayDetails',
    invoiceDetails: '_invoiceDetails',
};
var _registerRequest = { formInfo: '_formInfo' };
var _registerResponse = { booking: '_booking' };
var _setOfSessions = {
    firstSessionStart: 'google.protobuf.Timestamp',
    lastSessionEnd: 'google.protobuf.Timestamp',
};
var _singleSession = {
    start: 'google.protobuf.Timestamp',
    end: 'google.protobuf.Timestamp',
};
var _wixPayDetails = { orderApprovalTime: 'google.protobuf.Timestamp' };
function resolveComWixBookingsApiV1WaitingListUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/waiting-list-server',
                destPath: '',
            },
        ],
        'bookings._base_domain_': [
            {
                srcPath: '/waiting-list-server',
                destPath: '',
            },
            {
                srcPath: '/_api/waiting-list-server',
                destPath: '/api',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/waiting-list-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/waiting-list-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/waitlist',
                destPath: '/v1/waitlist',
            },
        ],
        _: [
            {
                srcPath: '/_api/waiting-list-server',
                destPath: '',
            },
            {
                srcPath: '/waiting-list-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Registers a site member to a waitlist.
 * If the requested session does not have a waitlist, or if the waitlist is already full, an error is received.
 * > **Permissions**
 * > This endpoint requires the Manage Bookings permissions scope
 */
export function register(payload) {
    var _a = serializer(_registerRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _contactDetails: _contactDetails,
        _formInfo: _formInfo,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_registerResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookedEntity: _bookedEntity,
        _booking: _booking,
        _contactDetails: _contactDetails,
        _formInfo: _formInfo,
        _invoiceDetails: _invoiceDetails,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _paymentDetails: _paymentDetails,
        _setOfSessions: _setOfSessions,
        _singleSession: _singleSession,
        _wixPayDetails: _wixPayDetails,
    }).fromJSON;
    function __register(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.waiting_list',
            method: 'POST',
            methodFqn: 'com.wix.bookings.api.v1.WaitingList.Register',
            url: resolveComWixBookingsApiV1WaitingListUrl({
                protoPath: '/v1/waitingList',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __register.fromReq = fromReq;
    __register.__isAmbassador = true;
    return __register;
}
/**
 * Removes a site member's registration to a waitlist (and cancels the associated pending-state booking).
 * If a spot has become available for booking and the server is SUGGESTING registration to waitlist registrants, the next member registered to the waitlist will receive an invitation to the opened spot.
 * > **Permissions**
 * > This endpoint requires the Manage Bookings permissions scope
 */
export function leave(payload) {
    var _a = serializer(_leaveRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_leaveResponse, {}).fromJSON;
    function __leave(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.waiting_list',
            method: 'POST',
            methodFqn: 'com.wix.bookings.api.v1.WaitingList.Leave',
            url: resolveComWixBookingsApiV1WaitingListUrl({
                protoPath: '/v1/waitlist/leave',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __leave.fromReq = fromReq;
    __leave.__isAmbassador = true;
    return __leave;
}
/**
 * Books a site member into the session for which they are waitlisted (waiting resource), and the associated booking is checked out.
 * Waitlist registration status is changed to ENROLLED.
 * > **Permissions**
 * > This endpoint requires the Manage Bookings permissions scope
 */
export function enroll(payload) {
    var _a = serializer(_enrollRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_enrollResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _bookedEntity: _bookedEntity,
        _booking: _booking,
        _contactDetails: _contactDetails,
        _formInfo: _formInfo,
        _invoiceDetails: _invoiceDetails,
        _location: _location,
        _locationsAddress: _locationsAddress,
        _locationsAddressLocation: _locationsAddressLocation,
        _locationsLocation: _locationsLocation,
        _paymentDetails: _paymentDetails,
        _setOfSessions: _setOfSessions,
        _singleSession: _singleSession,
        _wixPayDetails: _wixPayDetails,
    }).fromJSON;
    function __enroll(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.waiting_list',
            method: 'POST',
            methodFqn: 'com.wix.bookings.api.v1.WaitingList.Enroll',
            url: resolveComWixBookingsApiV1WaitingListUrl({
                protoPath: '/v1/waitingList/{registrationId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __enroll.fromReq = fromReq;
    __enroll.__isAmbassador = true;
    return __enroll;
}
/**
 * Returns a list of waitlisted entries.
 * Each WaitingListEntry returned holds the current Waitlist registrations, configuration and suggesting status.
 * > **Permissions**
 * > This endpoint requires the Read Bookings - Public Data permissions scope
 */
export function list(payload) {
    var _a = serializer(_listWaitingListRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listWaitingListResponse, {}).fromJSON;
    function __list(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.waiting_list',
            method: 'GET',
            methodFqn: 'com.wix.bookings.api.v1.WaitingList.List',
            url: resolveComWixBookingsApiV1WaitingListUrl({
                protoPath: '/v1/waitingList',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixBookingsApiV1WaitingListUrl({
                        protoPath: '/v1/waitingList',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __list.fromReq = fromReq;
    __list.__isAmbassador = true;
    return __list;
}
//# sourceMappingURL=http.impl.js.map